import { apiWorker } from "../apiWorker";

export function getAccessToken({
  onSuccess,
  onError,
  code,
}: {
  code: string;
  onSuccess?: (data: any) => void;
  onError?: (data: any) => void;
}) {
  apiWorker({
    body: {
      code,
    },
    url: `/integrations/spotify/auth`,
    method: "POST",
    onSuccess,
    onError,
  });
}
export function getUserPlaylists({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: any) => void;
  onError?: (data: any) => void;
}) {
  apiWorker({
    url: `/integrations/spotify/playlists`,
    method: "GET",
    onSuccess,
    onError,
  });
}
